import React, { Component } from 'react';
import { $ } from 'rype-bootstrap';
import { compose } from 'redux';
import { connect } from 'react-redux';

import ModalDecorator from 'hocs/ModalDecorator';
import Loading from 'components/Loading/Loading';

import { rescheduleTeacherReservation } from 'actions/Teacher/reservationActions';

import './style.css';

class RescheduleReservationModal extends Component {
  constructor() {
    super();

    $.noConflict();

    this.state = {
      note: ''
    };
  }

  componentDidMount() {
    // the HOC ModalDecorator adds and removes this modal from the DOM.
    //
    // once the component mounts, we need to manually add call show
    // to force Bootstrap to render the modal
    //
    // the delay is present to smooth the transitions
    // while the component continues to load
    setTimeout(() => $('#reschedule-reservation-modal').modal('show'), 75);

    // set up an event listener to call this.props.closeModal
    // whenever the modal is hidden.
    // closeModal comes from ModalDecorator, and causes
    // the element to be removed from the DOM
    $('#reschedule-reservation-modal').on('hidden.bs.modal', () => {
      this.props.closeModal();
    });
  }

  close = () => {
    // Call 'hide' to reset all the Bootstrap styling
    $('#reschedule-reservation-modal').modal('hide');
  }

  handleChange = (event) => {
    this.setState({ note: event.target.value });
  }

  handleReschedule = () => {
    const { modalProps, rescheduleTeacherReservation: rescheduleTeacherReservationFn } = this.props;

    rescheduleTeacherReservationFn({ ...modalProps, note: this.state.note }, () => {
      this.close();
    });
  }

  render() {
    const { note } = this.state;
    const {
      modalProps: { firstName }
    } = this.props;

    return (
      <div
        id="reschedule-reservation-modal"
        className="reschedule-reservation-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="reschedule-reservation-label"
        aria-hidden="true"
        data-backdrop="true"
      >
        <div className="modal-dialog modal-dialog-centered mx-auto" role="document">
          <div className="modal-content">
            <div className="modal-body p-0">
              <div className="m-4 m-sm-5">
                <h4 className="reschedule-reservation-modal__title m-0">
                  Reschedule your lesson with {firstName}
                </h4>
                <div className="form-group">
                  <label className="reschedule-reservation-modal__text my-3" htmlFor="textarea">
                    Let your student know why you need to reschedule this lesson. We&#39;ll include your
                    message when we ask them to reschedule.
                  </label>
                  <textarea
                    value={note}
                    className="reschedule-reservation-modal__text form-control"
                    id="textarea"
                    rows="8"
                    placeholder="Share why you need to reschedule your lesson..."
                    onChange={this.handleChange}
                  />
                </div>
                <div className="d-flex justify-content-around">
                  {this.props.rescheduleStatus === 'LOADING' ? (
                    <Loading />
                  ) : (
                    <button
                      type="button"
                      className="btn btn-blue btn-cursor w-100"
                      onClick={this.handleReschedule}
                      disabled={!Boolean(note.length)}
                    >
                      Reschedule
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    modalProps: state.visibleModal.props,
    rescheduleStatus: state.teacher.rescheduleStatus
  };
}

export default compose(
  ModalDecorator('reschedule-reservation-modal'),
  connect(
    mapStateToProps,
    { rescheduleTeacherReservation }
  )
)(RescheduleReservationModal);



// WEBPACK FOOTER //
// ./src/components/modals/RescheduleReservationModal/index.js